/*!
VueLayers
Web map Vue components with the power of OpenLayers

@package vuelayers
@author Vladimir Vershinin <ghettovoice@gmail.com>
@version 0.10.25
@license MIT
@copyright (c) 2017-2018, Vladimir Vershinin <ghettovoice@gmail.com>
*/
'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var Vue = _interopDefault(require('vue'));

var methods = {
  /**
   * @return {{
   *     setSource: function(ol.source.Source): void,
   *     getSource: function(): ol.source.Source
   *   }|undefined}
   * @protected
   */
  getSourceTarget: function getSourceTarget() {
    throw new Error('Not implemented method');
  },

  /**
   * @return {ol.source.Source|undefined}
   */
  getSource: function getSource() {
    return this._source;
  },

  /**
   * @returns {Object}
   * @protected
   */
  getServices: function getServices() {
    var vm = this;

    return {
      get sourceContainer() {
        return vm;
      }
    };
  },

  /**
   * @param {ol.source.Source|Vue|undefined} source
   * @return {void}
   */
  setSource: function setSource(source) {
    source = source instanceof Vue ? source.$source : source;

    if (source !== this._source) {
      this._source = source;
    }

    var sourceTarget = this.getSourceTarget();
    if (sourceTarget && source !== sourceTarget.getSource()) {
      sourceTarget.setSource(source);
    }
  }
};

var sourceContainer = {
  methods: methods,
  created: function created() {
    /**
     * @type {ol.source.Source|undefined}
     * @private
     */
    this._source = undefined;
  }
};

module.exports = sourceContainer;



//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/lib/mixin/source-container.js
// module id = 237
// module chunks = 1